// extracted by mini-css-extract-plugin
module.exports = {"blogLanding":"Blog_blogLanding__xYUgk"};